<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Observasi">
            <common-training-header/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.data"
                :loading="loading"
                rowKey="id"
                bordered>

                <a-table-column key="photo" title="Foto" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div style="text-align: center">
                            <img :src="record.user.photo" v-if="record.user.photo != null" height="50" />
                            <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.user.name) }}</a-avatar>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.user.name }}
                    </template>
                </a-table-column>

                <a-table-column key="branch" title="Cabang" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.branch.name }}
                    </template>
                </a-table-column>

                <a-table-column key="majors" title="Jurusan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.user.majors }}
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tooltip title="Detail">
                            <a-button
                                style="margin-right: 4px"
                                size="small"
                                icon="ellipsis"
                                @click="showModal(record.user.hash)"
                            />
                        </a-tooltip>
                    </template>
                </a-table-column>
            </a-table>
        </a-card>

      <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
        >
            <classical-observation-detail
                :attendant="this.attendant"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        training: {
            type: Object
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            expand: false,
            visible: false,
            attendant: null,
            processing: false,
            loading: false,
            items: {},
            filters: {
                q: null,
                email: null,
                page: 1
            }
        }
    },
    created() {
        this.items = this.getDefaultPagination()
        this.filters = _.merge(this.filters, this.$laravel.request)
        this.getItems()
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()
            this.pushState(this.filters)
            this.getItems()
        },
        handleReset(e) {
            e.preventDefault()
            this.filters = {
                q: null,
                page: 1
            }
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current
            this.pushState(this.filters)
            this.getItems()
        },
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.classical.observation.index'), {
                    params: this.filters
                })
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })

            this.getItems()
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        showModal(hash) {
            this.attendant = hash
            this.visible = true
        },
        closeModal(isRefresh) {
            this.visible = false
        }
    }
}
</script>
